/*Dependencies*/
import React from "react";
import { settingsCertificado } from "../utils";

/**Components */
import { Row, Col, Container } from "react-bootstrap";
import Slider from "react-slick";

/**Styles */
import "../styles/nosotros.scss";

/**Images */
import bannerValores from "../images2/img-valores.png";

export const Nosotros = () => {
  let arrCertificados = [
    {
      title: "Integridad",
      desc: "En las acciones, el servicio y la colaboración de la empresa, priorizando el bienestar común de las personas.",
    },
    {
      title: "Lealtad",
      desc: "Con nuestros colaboradores, clientes y proveedores.",
    },
    {
      title: "Entusiasmo",
      desc: "En la búsqueda de un viaje ideal, fácil, memorable y a un precio justo.",
    },
    { title: "Asertividad", desc: "Siempre ante cualquier situación." },
  ];
  return (
    <div className="nosotros">
      <div className="container text-terminos border-top border-black text-center">
        <div className="pt-5">
          <h5 style={{ fontSize: "25px" }}>Somos viajeros como tú</h5>
          <h1 className="fw-bold" style={{ fontSize: "60px" }}>
            Nuestra pasión <br /> es vivir cada <br /> viaje
          </h1>
        </div>
      </div>
      <div className="container section-vision py-2">
        <Row>
          <Col lg={6}>
            <img
              src={bannerValores}
              alt="banner"
              style={{ width: "100%", height: "100%" }}
            />
          </Col>
          <Col
            lg={6}
            className="d-flex flex-column justify-content-center mt-5"
          >
            <div className="mb-4">
              <div className="d-flex">
                <div id="circle" className="mx-3"></div>
                <h5 className="fw-bold" style={{ fontSize: "25px" }}>
                  Nuestra misión
                </h5>
              </div>

              <p className="text-secondary mx-5">
                Conectar a los viajeros con el mundo para hacerlos sentir parte
                de su destino.
              </p>
            </div>
            <div className="mb-4">
              <div className="d-flex">
                <div id="circle" className="mx-3"></div>
                <h5 className="fw-bold" style={{ fontSize: "25px" }}>
                  Nuestra visión
                </h5>
              </div>
              <p className="text-secondary mx-5">
                Ser una de las plataformas de viajes favoritas para coleccionar
                experiencias en familia, con amigos o por negocios.
              </p>
            </div>
            <div>
              <div className="d-flex">
                <div id="circle" className="mx-3"></div>
                <h5 className="fw-bold" style={{ fontSize: "25px" }}>
                  Nuestra promesa
                </h5>
              </div>
              <p className="text-secondary mx-5">
                Inspirar a las personas a viajar con precios razonables y
                servicios cómodos.
              </p>
            </div>
          </Col>
        </Row>
      </div>
      <div className="container section-valores">
        <Row>
          <Col lg={6}>
            <div className="d-flex justify-content-between mt-lg-5 mt-3 align-items-center mb-4">
              <h3 className="text-lg-start text-center fw-bold title-home pb-3 mb-4 border-1 border-black border-bottom hotel-ideal">
                Conoce los valores de Marzah
              </h3>
            </div>
          </Col>
          <Col lg={6}>
            <div className="info-contact" style={{ padding: "50px 0" }}>
              <Slider {...settingsCertificado}>
                {arrCertificados.map((item, index) => (
                  <div
                    className="info-contact__box-style text-center"
                    key={index + 1}
                  >
                    <h5 className="mt-2">{item.title}</h5>
                    <p className="mt-2" style={{ fontSize: "15px" }}>
                      {item.desc}
                    </p>
                  </div>
                ))}
              </Slider>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
